// cursor
// https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#keyword
export const CURSOR_AUTO = 'auto'
export const CURSOR_CROSSHAIR = 'crosshair'
export const CURSOR_DEFAULT = 'default'
export const CURSOR_GRAB = 'grab'
export const CURSOR_GRABBING = 'grabbing'
export const CURSOR_HELP = 'help'
export const CURSOR_NOT_ALLOWED = 'not-allowed'
export const CURSOR_POINTER = 'pointer'
export const CURSOR_ZOOM_IN = 'zoom-in'
export const CURSOR_WAIT = 'wait'
